
import { useState, useRef, React, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import HeaderMobile from './components/Header'
import { addDays, format } from 'date-fns'
import { Button, FormControl, Grid } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import BidGroup from './components/BidGroup'
import BidList from './components/BidList'
import BidHistory from './components/BidHistory'
import BidResult from './components/BidResult'
import { dateToString } from '../../utils/Library'
import { useAuth } from '../../contexts/AuthContext'
import { usePost } from '../../apis/ApiRequests'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import AddIcon from '@mui/icons-material/Add'

const BidManagerMobile = () => {
    
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo } = useAuth()
    const facilityCode = authInfo.facilityCode
    const facilityName = authInfo.facilityName
    const userId       = authInfo.userId
    const userName     = authInfo.userName
    const authority    = authInfo.authority
    const traderCode   = authInfo.traderCode
    const trader       = authInfo.trader

    const navigate = useNavigate()
    
    const search     = useLocation().search
    const query      = new URLSearchParams(search)
    const bidGroupNo = query.get('bidGroupNo')
    const targetDate = query.get('targetDate')
    const today      = targetDate ? targetDate : format(addDays(new Date(), 0), 'yyyy-MM-dd')
    
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
	const [ searchCount,    setSearchCount    ] = useState(0)
	const [ bidGroup,       setBidGroup       ] = useState([])
	const [ bidList,        setBidList        ] = useState([])
    const [ bidHistoryList, setBidHistoryList ] = useState([])
    const [ bidResultList,  setBidResultList  ] = useState([])
	const [ display_tab,    setDisplay_tab    ] = useState("1")
	const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 460)
    const [ requireMessage, setRequireMessage ] = useState('')
    
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue     : false,
        snackBarFalse    : false,
        require          : false,
        confirm          : false,
        confirm_register : false
    })
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - getData / BidGroup
	//-----------------------------------------------
    const { response : getData_res, loading : getData_Loading, post:getData_post } = usePost()
    const getData = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo
        }
        await getData_post(postData)
    }
	//-----------------------------------------------
    // API - getDataInGroup / BidList
	//-----------------------------------------------
    const { response : getDataInGroup_res, loading : getDataInGroup_Loading, post:getDataInGroup_post } = usePost()
    const getDataInGroup = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getDataInGroup',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo
        }
        await getDataInGroup_post(postData)
    }
    //-----------------------------------------------
    // API - searchData / BidHistory
    //-----------------------------------------------
    const { response : searchData_history_res, loading : searchData_history_Loading, post:searchData_history_post } = usePost()
    const searchData_history = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidHistory',
            'methodName'   : 'searchDataByTrader',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo,
            'traderCode'   : traderCode,
            'entryUserId'  : userId
        }
        await searchData_history_post(postData)
    }
    //-----------------------------------------------
    // API - searchData / BidHistory
    //-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
    const searchData = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidHistory',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'bidGroupNo'   : bidGroupNo,
            'traderCode'   : traderCode,
            'entryUserId'  : userId
        }
        await searchData_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1)
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 460)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        getData()
        getDataInGroup()
        searchData_history()
        searchData()
    }, [searchCount])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_res) {
            setBidGroup({ ...getData_res })
            if (!getData_res.bidGroupNo) {
                navigate(`/bidGroupMobile?targetDate=${today}&bidGroupNo=${bidGroupNo}`)
            }
        }
    }, [getData_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / unloadList)
	//-----------------------------------------------
    useEffect(() => {
        setBidList([])
        if (getDataInGroup_res) {
            setBidList(getDataInGroup_res.Data )
        }
    }, [getDataInGroup_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / bidHistory)
	//-----------------------------------------------
    useEffect(() => {
        setBidHistoryList([])
        if (searchData_history_res) {
            setBidHistoryList(searchData_history_res.Data)
        }
    }, [searchData_history_res])
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / bidHistory)
	//-----------------------------------------------
    useEffect(() => {
        setBidResultList([])
        if (searchData_res) {
            setBidResultList(searchData_res.Data)
        }
    }, [searchData_res])
    
    const handleClick = (seq, entryUserId) => {
        if (bidGroup.groupStatus != 9 && bidGroup.groupStatus != 8) {
            if (userId == entryUserId) {
                navigate(`/bidRegisterMobile?targetDate=${today}&bidGroupNo=${ bidGroupNo }&seq=${ seq }`)
            } else {
                setRequireMessage('入札情報の変更は同一ユーザのみ可能です')
                setMessageInfo('require', true)
            }
        }
    }
    const handleChange_groupNo = (event, newAlignment) => {
        setDisplay_tab(newAlignment)
        setSearchCount(searchCount+1)
    }
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }))
    }

    return (
        <>
            <HeaderMobile />
            <div className='bidList bodyContens' style={{marginTop:'70px'}}>
                <BidGroup bidGroup = {bidGroup}/>
                <div>
                    <ToggleButtonGroup
                        value={display_tab}
                        exclusive
                        onChange={handleChange_groupNo}
                        aria-label="text alignment"
                        color   = "secondary"
                        sx={{ 
                            // ToggleButtonGroupに適用するスタイル
                            backgroundColor: 'lightgray',
                            '& .MuiToggleButtonGroup-grouped': {
                                border: 0, padding:1, width:'110px', fontWeight:'bold', borderRadius:'5px', fontSize:'18px',
                                '&.Mui-selected': {
                                    backgroundColor: '#305496',
                                    color: 'white',
                                },
                                '&:not(:first-of-type)': {
                                    borderRadius: '5',
                                },
                                '&:first-of-type': {
                                    borderRadius: '5',
                                },
                                '&:hover': {
                                    // ホバー時のスタイル
                                    opacity: 0.7,
                                    backgroundColor: '#305496', // ホバー時の背景色
                                    color: 'white', // ホバー時の文字色
                                },
                            },
                            '& .MuiToggleButtonGroup-grouped.Mui-selected:hover': {
                                // 選択済みのボタンのホバースタイル
                                backgroundColor: '#305496', // 例: ダークブルーの背景色
                                color: 'white', // 例: 白いテキスト色
                            },
                        }}
                    >
                        <ToggleButton value="1" aria-label="option 1">入札状況</ToggleButton>
                        <ToggleButton value="0" aria-label="option 0">入札明細</ToggleButton>
                        <ToggleButton value="2" aria-label="option 2">落札結果</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div style={{marginTop:'1em', backgroundColor:'#fff',border : '1px solid #ababab',borderRadius : '10px', padding : '10px', width: '100%', height: dataGridHeight, marginBottom: '10px', overflowY:'scroll'}}>

                { display_tab == "0" ?
                    <>
                        {
                            bidList.map(item => (
                                <div>
                                    <BidList bidList = {item}/>
                                </div>
                            ))
                        }
                    </>
                    :
                    <></>
                }
                { display_tab == "1" ?
                    <>
                        {
                            bidHistoryList.map(item => (
                                <div>
                                    <BidHistory bidHistory = {item} onClick={ () => handleClick(item.seq, item.entryUserId) }/>
                                </div>
                            ))
                        }
                    </>
                    :
                    <></>
                }
                { display_tab == "2" ?
                    <>
                        {
                            bidResultList.filter(row => row.bidStatus === 1).map(item => (
                                <div>
                                    <BidResult bidHistory={ item } traderCode={traderCode} bidGroup={bidGroup} />
                                </div>
                            ))
                        }
                    </>
                    :
                    <></>
                }
                </div>
                <div style={{ position: 'fixed', left: 0, bottom: 0, width: '100%', color: 'white', textAlign: 'center', }}>
                    {
                    (bidGroup.groupStatus != 9 && bidGroup.groupStatus != 8) ?
                    <>
                    <Button
                        color     = "secondary"
                        size      = "large"
                        style     = {{ fontSize: '20px', width: '90%',margin: '1rem', color:'#fff', }}
                        variant   = "contained"
                        startIcon = {<AddIcon />}
                        onClick   = {() => { navigate(`/bidRegisterMobile?targetDate=${today}&bidGroupNo=${ bidGroupNo }&seq=`) }}
                    >
                    入札登録を行う
                    </Button>
                    </>
                    :
                    <></>
                    }
                    <Button
                        color     = "secondary"
                        size      = "large"
                        style     = {{ fontSize: '20px', width: '90%',marginBottom: '1rem', color:'#fff', backgroundColor:'grey' }}
                        variant   = "contained"
                        startIcon = {<InfoIcon />}
                        onClick   = {() => { navigate(`/bidGroupMobile?targetDate=${today}&bidGroupNo=${ bidGroupNo }`) }}
                    >
                    入札リストへ戻る
                    </Button>
                </div>
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
            </div>
        </>
    )
}

export default BidManagerMobile